import { graphql } from 'react-relay';

import { ProductWindowPaginator_query$key } from '../../../relay/__generated__/ProductWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const ProductWindowPaginator_query = graphql`
  fragment ProductWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: ProductFilter }
    order: { type: ProductOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "ProductWindowPaginatorRefreshQuery") {
    products(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...ProductConnectionDataTable_productConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<ProductWindowPaginator_query$key>, 'fragment'>;

const ProductWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={ProductWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.products.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default ProductWindowPaginator;
